import { GSPCommonModel, IGSPCommonObject, GSPCommonObject } from '../../common-model';

export class CommonModelUtil {

  public static GetGeneratedConfigID(cm: GSPCommonModel): string {
    if (cm.IsUseNamespaceConfig) {
      return cm.GeneratingAssembly + '.' + cm.Code;
    }
    return cm.Code;
  }


  private static findObjectFromObjectByID(obj: IGSPCommonObject, objId: string): any {
    let result: IGSPCommonObject = null;

    if (!obj) {
      return null;
    }

    if (obj.ID === objId) {
      return obj;
    }

    if (!obj.ContainChildObjects) {
      return null;
    }
    // 递归查找子节点
    if (obj.ContainChildObjects.length > 0) {
      for (let i = 0; i < obj.ContainChildObjects.length; i++) {
        if (obj.ContainChildObjects[i].ID === objId) {
          result = obj.ContainChildObjects[i];
          return result;
        }

        result = this.findObjectFromObjectByID(obj.ContainChildObjects[i], objId);
        if (result != null) {
          return result;
        }
      }
    }

    return result;
  }

  /**
   * 根据objId查找对象
   * @param objId
   */
  public findObjectById(cm: GSPCommonModel, objId: string): GSPCommonObject {
    let result: GSPCommonObject = null;
    result = CommonModelUtil.findObjectFromObjectByID(cm.MainObject, objId);
    return result;
  }

}
